export default __webpack_public_path__ + "static/media/error.ebc5d7ab.svg";